import { render } from "./modify-password.vue?vue&type=template&id=60ac892c"
import script from "./modify-password.vue?vue&type=script&lang=js"
export * from "./modify-password.vue?vue&type=script&lang=js"

import "./modify-password.vue?vue&type=style&index=0&id=60ac892c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__